import React, { forwardRef } from 'react'
import styled from 'react-emotion'
import { border, interactive as interactiveStyles, color } from '../../style'

export const Label = styled(
  forwardRef(
    (
      {
        className,
        as,
        flex,
        autoWidth,
        notSelected,
        interactive,
        medium,
        active,
        primary,
        align,
        grey,
        danger,
        xLarge,
        ...props
      },
      ref
    ) => {
      const Component = as || 'span'
      return <Component {...props} className={className + ' label'} ref={ref} />
    }
  )
)(props => {
  const {
    flex,
    autoWidth,
    interactive,
    medium,
    align,
    grey,
    danger,
    xLarge
  } = props
  const size = medium ? 30 : xLarge ? 60 : 20
  let padding = medium ? 10 : xLarge ? 20 : 5
  let style = {
    label: 'Label',

    fontWeight: 500,
    color: danger && 'white',

    display: 'flex', // needed for alignItems
    flex: flex === true ? 1 : flex,
    alignItems: 'center', // vertically center text
    justifyContent:
      align === 'left'
        ? 'flex-start'
        : align === 'right'
        ? 'flex-end'
        : 'center', // horizontally center when scretched out
    lineHeight: 1,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    textAlign: 'left',
    fontSize: xLarge && 16,
    border: border,
    borderRadius: xLarge ? 4 : 2,
    borderWidth: xLarge && 2,
    background: grey ? color.greyBlock : danger ? color.red : '#fff',

    height: size,
    width: flex === true ? '100%' : autoWidth && 'auto',
    minWidth: size,

    paddingLeft: padding,
    paddingRight: padding,

    '& > *:not(:last-child)': {
      marginRight: 5
    },
    '& > *:not(:first-child)': {
      marginLeft: 5
    },

    [`${LabelSet} &`]: {
      '&:not(:last-child)': {
        marginRight: -1,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      '&:not(:first-child)': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }
  if (interactive) style = { ...style, ...interactiveStyles(props) }
  return style
})

export const LabelSpacer = styled('span')({
  label: 'LabelSpacer',
  flex: 1
})

export const LabelSet = styled('div')(({ stretch }) => ({
  label: 'LabelSet',
  display: 'flex',
  flex: stretch && 1,
  '& > *': stretch && { flex: 1 }
}))

export const LabelGroup = styled('div')({
  label: 'LabelGroup',
  display: 'flex',
  '& > *:not(:first-child)': {
    marginLeft: 5
  }
})

export default Label
